import {
  useGetOrganisationOrganisationidAccountNumbers,
  useGetTerminalOrganisationidAccountNumbers,
  type UserType,
} from '@dhl/mdp-api'
import { isBusinessUser } from '~/modules/users/model'
import type { OrganisationType } from '~/modules/organisations/model'

export const useOrganisatonAccounts = (
  userType: UserType | undefined,
  organisationId: string | undefined,
  organisationType: OrganisationType
) => {
  const enabled = (!userType || isBusinessUser(userType)) && !!organisationId

  const {
    data: organisationAccountDtos,
    isFetching: isFetchingOrganisationAccountDtos,
    refetch: refetchOrganisationAccountDtos,
  } = useGetOrganisationOrganisationidAccountNumbers(organisationId || '', {
    query: {
      enabled: enabled && organisationType === 'organisation',
    },
  })

  const {
    data: terminalAccountDtos,
    isFetching: isFetchingTerminalAccountDtos,
    refetch: refetchTerminalAccountDtos,
  } = useGetTerminalOrganisationidAccountNumbers(organisationId || '', {
    query: {
      enabled: enabled && organisationType === 'terminal',
    },
  })

  const accountDtos = organisationAccountDtos || terminalAccountDtos || []

  // Slice makes a copy of the array first. This is needed because the sort method mutates the array.
  const sortedAccountDtos = accountDtos.slice().sort((a, b) => (a.id < b.id ? -1 : 1))

  return {
    accountDtos: sortedAccountDtos,
    isFetching: organisationType === 'terminal' ? isFetchingTerminalAccountDtos : isFetchingOrganisationAccountDtos,
    refetch: organisationType === 'terminal' ? refetchTerminalAccountDtos : refetchOrganisationAccountDtos,
  }
}
